/** @jsx jsx */
import { jsx, Box, Flex, Text, Card } from 'theme-ui'
import Accordian from '../accordion'
import styles from './subscriptions.styles'

const Subscriptions = () => {

  return (
    <Card variant="slim">
      <Accordian open heading='Subscriptions' variant="light">
        <Box p={4}>
          <Flex sx={styles.cardWrapper}>
          <Card
            variant="slim"
            sx={styles.card}
          >
            <Accordian open heading='Live Streaming'>
              <Box p={4}>
                <Text as="a" sx={styles.link} target="_blank" href={`${process.env.GATSBY_STREAMAMG_URL}/account`}>Click here to manage your account</Text>
              </Box>
            </Accordian>
          </Card>
        </Flex>
        </Box>
      </Accordian>
    </Card>
  )
}

export default Subscriptions
